import React, { Component, forwardRef } from 'react';
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../utils/withRouter";
import Modal from 'react-bootstrap/Modal';
import { connect } from "react-redux";
import { toastError, toastSuccess, } from '../../../utils/constants'
import { fill_action } from '../../../actions/fillCombo_action'
import Pagination from '../../../utils/pagination'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Workbook from 'react-excel-workbook'
import Header from '../../../common_components/Header';
import { insertUpdateBlog_action, getBlogDetails_action } from '../../../actions/adminAction/blog_action'
import JoditEditor from "jodit-react";
import Switch from "react-switch";

const config = {
    readonly: false,
    height: 700,
    placeholder: "",
    disableBeautify: true,
    useAceEditor: false,
    uploader: { insertImageAsBase64URI: true },
    toolbarSticky: false,
    showAbout: false,
    showPoweredBy: false
}
class BlogAU extends Component {

    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isAdd: false,
            isUpdate: false,
            BlogID: '',
            title: '',
            Content: null,
            IsActive: '',
            ContentErr: ''
        }
    }

    // On Component Load
    componentDidMount() {
        if (JSON.parse(sessionStorage.getItem("loginDataSS")) == null) {
            setTimeout(() => {
                this.props.navigate('/');
            }, 200);
        } else {

            this.setState({
                isAdd: this.props.location.state != null && this.props.location.state.is_add ? this.props.location.state.is_add : false,
                isUpdate: this.props.location.state != null && this.props.location.state.is_update ? this.props.location.state.is_update : false,
                BlogID: this.props.location.state != null && this.props.location.state.BlogID ? this.props.location.state.BlogID : '',
                IsActive: this.props.location.state != null && this.props.location.state.IsActive ? this.props.location.state.IsActive : '',
            })
            setTimeout(() => {
                this.props.location.state != null && this.props.location.state.is_update && this.getBlogDetails()
            }, 300);
        }
    }

    getBlogDetails() {
        const { } = this.state
        this.setState({ isLoading: true })
        var Id = this.props.location.state.BlogID
        this.props
            .getBlogDetails_action(Id)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({
                        isLoading: false,
                        title: data.data[0]['Title'],
                        Content: data.data[0]['Details']
                    })

                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    insertUpdateBlog() {
        const { title, Content, isAdd, IsActive } = this.state
        var Id = this.props.location.state.BlogID
        if (title != '' && title != null) {
            if (Content != '' && Content != null && Content != "<p><br></p>") {
                this.setState({ isLoading: true })
                this.props
                    .insertUpdateBlog_action(Id, title, Content, IsActive)
                    .then((data) => {
                        if (data.error != 1) {
                            if (isAdd) {
                                toastSuccess("Data inserted successfully!")
                            } else {
                                toastSuccess("Data updated successfully!")
                            }
                            this.setState({
                                isLoading: false
                            })
                            setTimeout(() => {
                                this.props.navigate('/blogList')
                            }, 1000);
                        }
                        else {
                            this.setState({ isLoading: false })
                            toastError(data.msg)
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                    });
            } else {
                toastError("Please enter blog content")
            }
        } else {
            toastError("Please enter title")
            this.setState({ ContentErr: 'Please enter title' })
        }
    }

    render() {
        const { isLoading, title, isAdd, isUpdate, ContentErr } = this.state

        return (<>
            {isLoading ? (
                <Loader></Loader>
            ) : (
                null
            )}
            <ToastContainer />
            <Header />
            <section class="receipt-section" style={{ marginBottom: '50px', marginTop: '125px' }}>
                <div class="container">
                    <div class="row">
                        <div class="col-12 col-sm-12 col-lg-12">
                            <div class="card ">
                                <div class="card-header">
                                    <div class="row">
                                        <div class="col-md-5 col-5">
                                            <h4 class="heading_title_text">Blog {isAdd ? "Add" : "Update"}</h4>
                                        </div>
                                        <div class="col-md-7 col-7 text-right">
                                            <div class="card-header-action">
                                                <Switch onChange={(event) => this.setState({ IsActive: event })} checked={this.state.IsActive} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="main-container p-2 mt-2">
                                    <div className="row ">
                                        <div className="col-6">
                                            <div class="form-group">
                                                <label>Title<span className="red-star text-danger">*</span></label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    defaultValue=""
                                                    required=""
                                                    value={title}
                                                    onChange={(e) => this.setState({ title: e.target.value, ContentErr: '' })}
                                                />
                                                {<span className='text-danger text-start text-left d-block  ml-2'>{ContentErr}</span>}
                                            </div>
                                        </div>

                                    </div>
                                    <div className="row">
                                        {/* <div className="col-2"></div> */}
                                        <div className="col-12">
                                            <div class="form-group">
                                                <div className="mt-2">
                                                    <JoditEditor
                                                        value={this.state.Content}
                                                        onChange={(event) => this.setState({ Content: event })}
                                                        config={config}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div className="col-2"></div> */}
                                    </div>
                                    <div className="row">
                                        <div
                                            className=" mb-1 mt-2"
                                            role="group"
                                            aria-label="Basic example"
                                            style={{ float: "right", textAlign: "right" }}
                                        >
                                            {
                                                isAdd &&
                                                <button type="button" className="btn btn-success ms-2"
                                                    onClick={() => this.insertUpdateBlog()}
                                                >
                                                    Save
                                                </button>
                                            }
                                            {
                                                isUpdate &&
                                                <button type="button" className="btn btn-success ms-2"
                                                    onClick={() => this.insertUpdateBlog()}
                                                >
                                                    Update
                                                </button>
                                            }
                                            <button type="button" className="btn btn-warning ms-2  text-white"
                                                onClick={() => this.props.navigate('/blogList')}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>)
    }
}

export default withRouter(connect(null, { fill_action, insertUpdateBlog_action, getBlogDetails_action })(BlogAU));
